











import { defineComponent } from '@vue/composition-api'
import AppBar from './components/AppBar.vue'
import Footer from './components/Footer.vue'

export default defineComponent({
  components: { AppBar, Footer },
  setup() {
    return {}
  },
})
